import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { position } from 'styled-system';
import gsap from 'gsap';

export default function Stacked(props) {
  const { children, direction, animationLayer } = props;
  const layerRefs = useRef([]);
  layerRefs.current = [];
  const addToRefs = (el) => {
    if (el && !layerRefs.current.includes(el)) {
      layerRefs.current.push(el);
    }
  };
  const changeReversed = (timeline) => {
    if (!timeline) {
      return;
    }
    timeline.reversed(!timeline.reversed());
  };
  const [tl0] = React.useState(
    gsap.timeline({
      paused: true,
      onComplete: changeReversed,
      onReverseComplete: changeReversed,
    })
  );
  const [tl1] = React.useState(
    gsap.timeline({
      paused: true,
      onComplete: changeReversed,
      onReverseComplete: changeReversed,
    })
  );
  const [tl2] = React.useState(
    gsap.timeline({
      paused: true,
      onComplete: changeReversed,
      onReverseComplete: changeReversed,
    })
  );

  useEffect(() => {
    const layers = layerRefs?.current?.map((layer, i) => {
      const tween = gsap.to(layer, {
        x: `25vw`,
        duration: 0.3,
        ease: `circ`,
      });
      let timeline = tl0;
      if (i === 1) {
        timeline = tl1;
      } else if (i === 2) {
        timeline = tl2;
      }
      return timeline.add(tween);
    });
    return () => {};
  }, []);

  useEffect(() => {
    const timelines = [tl0, tl1, tl2];
    if (direction === 'up') {
      timelines[animationLayer < 0 ? 0 : animationLayer].play().timeScale(1);
    } else if (direction === 'down') {
      timelines[animationLayer === children.length - 1 ? 1 : animationLayer - 1].reverse();
    }
    return () => {};
  }, [animationLayer, direction]);
  return (
    <Container>
      {children.map((item, i) => (
        <Layer
          layout
          key={item.title}
          zIndex={children.length - i}
          startingPosition={i * -8}
          id={`layer_${i}`}
          ref={(el) => i !== 2 && addToRefs(el)}
        >
          {item()}
        </Layer>
      ))}
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

const Layer = styled.div`
  height: auto;
  width: 100%;
  position: absolute;
  top: ${({ startingPosition }) => startingPosition * -2.5}%;
  right: ${({ startingPosition }) => startingPosition * -0.5}%;
  ${position};
  svg {
    width: 750px;
    height: 600px;
    filter: drop-shadow(-21px 105px 75px rgba(4, 10, 26, 0.7));
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      width: 325px;
      height: 100%;
    }
  }
`;
